export function insertTag() {

    return {
        require: 'ngModel',
        restrict: 'A',
        link: function ($scope, $element, attrs, ngModelCtrl) {

            angular.element(document).ready(() => {

                let btn = angular.element(document.getElementById(attrs.insertBtn));

                if (btn) {
                    btn.off('click').on('click', () => {

                        let start = $element[0].selectionStart;

                        let end = $element[0].selectionEnd;

                        if (ngModelCtrl.$viewValue) {

                            ngModelCtrl.$setViewValue(

                                ngModelCtrl.$viewValue.substring(0, start) +
                                attrs.tagValue +
                                ngModelCtrl.$viewValue.substring(end));

                        } else {
                            ngModelCtrl.$setViewValue(attrs.tagValue);
                        }

                            ngModelCtrl.$render();
                    });
                }

            });


        }
    }
}


// WEBPACK FOOTER //
// ./src/ui/directives/insert-tag.directive.js